import {
    CREATE_ACCESSORIES_REQUIREMENTS_REQUEST,
    CREATE_ACCESSORIES_REQUIREMENTS_SUCCESS,
    CREATE_ACCESSORIES_REQUIREMENTS_FAILURE,
    DELETE_ACCESSORIES_REQUIREMENTS_REQUEST,
    DELETE_ACCESSORIES_REQUIREMENTS_SUCCESS,
    DELETE_ACCESSORIES_REQUIREMENTS_FAILURE,
    FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_REQUEST,
    FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_FAILURE,
    FETCH_ACCESSORIES_REQUIREMENTS_REQUEST,
    FETCH_ACCESSORIES_REQUIREMENTS_SUCCESS,
    FETCH_ACCESSORIES_REQUIREMENTS_FAILURE,
    UPDATE_ACCESSORIES_REQUIREMENTS_REQUEST,
    UPDATE_ACCESSORIES_REQUIREMENTS_SUCCESS,
    UPDATE_ACCESSORIES_REQUIREMENTS_FAILURE,
    RESET_ACCESSORIES_REQUIREMENTS_INFO,
    CREATE_ACCESSORIES_REQUIREMENTS_FORM,
    UPDATE_ACCESSORIES_REQUIREMENTS_FORM,
    FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_FAILURE,
    RESPONSE_ACCESSORIES_REQUIREMENTS,
    FETCH_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST,
    FETCH_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS,
    FETCH_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE,
    RESET_ACCESSORIES_REQUIREMENT_INVOICE,
    GET_SINGLE_EDIT_CHECK_GET_REQUEST,
    GET_SINGLE_EDIT_CHECK_GET_SUCCESS,
    GET_SINGLE_EDIT_CHECK_GET_FAILURE
} from './accessoriesRequirement.actionsType';

export const ACCESSORIES_REQUIREMENTS = 'accessoriesRequirement';

let initialState = {
    loading: false,
    accessoriesRequirementsList: [],
    accessoriesRequirementsListByStyle: [],
    accessoriesRequirementsForm: {
        fldIsprocessrequired: false
    },
    selectedState: {},
    responseStatusAccessoriesReq: 200,
    errorMessage: '',
    accesReqInvoice: [],
    checkIds: []
};

export let accessoriesRequirementReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_REQUIREMENTS_REQUEST:
        case CREATE_ACCESSORIES_REQUIREMENTS_REQUEST:
        case UPDATE_ACCESSORIES_REQUIREMENTS_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_REQUEST:
        case FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_REQUEST:
        case DELETE_ACCESSORIES_REQUIREMENTS_REQUEST:
        case FETCH_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST:
        case GET_SINGLE_EDIT_CHECK_GET_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsList: updatePayload
            };
        case GET_SINGLE_EDIT_CHECK_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                checkIds: updatePayload
            };
        case FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsListByStyle: updatePayload
            };
        case CREATE_ACCESSORIES_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsForm: { fldIsprocessrequired: false }
            };
        case UPDATE_ACCESSORIES_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsForm: { fldIsprocessrequired: false },
                responseStatusAccessoriesReq: updatePayload
            };

        case FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsForm: {
                    fldId: updatePayload[0].FldCombineID,
                    fldFKAccessoriesMaster: updatePayload[0].PP[0].PD[0].AM[0].FldId,
                    fldAccessoriesName: updatePayload[0].PP[0].PD[0].AM[0].FldName,
                    fldConsumption: updatePayload[0].FldConsumption,
                    fldProcessLoss: updatePayload[0].FldProcessLoss,
                    fldFKUnitType: updatePayload[0].FldFKUnitType,
                    fldUnitPrice: updatePayload[0].FldUnitPrice,
                    fldFKDepartment: updatePayload[0].FldFKDepartment,
                    fldFKItem: updatePayload[0].FldFKItem,
                    fldLocation: updatePayload[0].FldLocation,
                    fldIsprocessrequired: updatePayload[0].FldIsprocessrequired,
                    FldFKSize: updatePayload[0].PP[0].PD[0].AM[0].FldFKSize,
                    FldFKColor: updatePayload[0].PP[0].PD[0].AM[0].FldFKColor,
                    fldFKSupplier: updatePayload[0].FldFKSupplier,
                    fldForSizes: updatePayload[0].FldForSizes,
                    FldPrice: updatePayload[0].FldPrice,
                    FldTotalProcessPrice: updatePayload[0].FldTotalProcessPrice,
                    FldIsAssignSizeWisePrice: updatePayload[0].FldIsAssignSizeWisePrice,
                    fldMatchStyleColor: updatePayload[0].FldMatchStyleColor,
                    fldPart: updatePayload[0].FldPart
                }
            };
        case DELETE_ACCESSORIES_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsForm: { fldIsprocessrequired: false },
                deleteErrorMessage: updatePayload !== 200 ? updatePayload : ''

            };
        case FETCH_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accesReqInvoice: updatePayload
            };
        case RESET_ACCESSORIES_REQUIREMENT_INVOICE:
            return {
                ...state,
                accesReqInvoice: []
            };
        case RESET_ACCESSORIES_REQUIREMENTS_INFO:
            return {
                ...state,
                accessoriesRequirementsForm: { fldIsprocessrequired: false }
            };
        case RESPONSE_ACCESSORIES_REQUIREMENTS:
            return {
                ...state,
                responseStatusAccessoriesReq: payload
            };
        case CREATE_ACCESSORIES_REQUIREMENTS_FORM:
        case UPDATE_ACCESSORIES_REQUIREMENTS_FORM:
            return {
                ...state,
                loading: false,
                accessoriesRequirementsForm: {
                    ...state.accessoriesRequirementsForm,
                    [payload.key]: payload.value
                }
            };
        case UPDATE_ACCESSORIES_REQUIREMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                responseStatusAccessoriesReq: 'edit'
            };
        case CREATE_ACCESSORIES_REQUIREMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                responseStatusAccessoriesReq: 200
            };
        case FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                accessoriesRequirementsListByStyle: [],
                ...state,
                loading: false
            };
        case FETCH_ACCESSORIES_REQUIREMENTS_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_FAILURE:
        case DELETE_ACCESSORIES_REQUIREMENTS_FAILURE:
        case FETCH_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE:
        case GET_SINGLE_EDIT_CHECK_GET_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
